export default __webpack_public_path__ + "static/media/icon-select-blue.7c96a076.svg";